import React from 'react';

import { InventoryTabItemName } from '../../../../../InventoryStore';
import {
  useInventoryHeaderState,
  useInventoryState,
} from '../../../../../hooks';
import { useReadOnlyRowConfig } from '../../../../../hooks/useReadOnlyRowConfig';
import { isDateAfterEndOfSale, isDatePast } from '../../../../../utils';
import type { RoomOpeningInventory } from '../../../../../utils/rooms';
import { CheckboxCell } from '../../../../Table/Cells/CheckboxCell/CheckboxCell';
import { LabelCell } from '../../../../Table/Cells/LabelCell/LabelCell';
import { PureFieldCell } from '../../../../Table/Cells/PureFieldCell/PureFieldCell';
import { TableRow } from '../../../../Table/TableRow/TableRow';
import { isEnabledByMessage } from '../../../tabViewUtils';

const RoomStopSellRowComponent: React.FC<{ roomId: number }> = ({ roomId }) => {
  const { isEditMode } = useInventoryHeaderState();
  const { endOfSaleDate } = useInventoryState();

  const { inventoryRooms, dateKeys } = useReadOnlyRowConfig(
    InventoryTabItemName.Rooms
  );

  if (!inventoryRooms) {
    return null;
  }

  return (
    <TableRow>
      <LabelCell label="Stop sell" />
      {dateKeys.map((dateKey) => {
        const fieldName = [dateKey, `${roomId}`];
        const closedFieldName = [...fieldName, 'isClosedByHotel'];
        const isPast = isDatePast(dateKey);
        const isGrayed = isPast || isDateAfterEndOfSale(dateKey, endOfSaleDate);

        return (
          <PureFieldCell key={dateKey} name={fieldName} dateKey={dateKey}>
            {(values?: RoomOpeningInventory) => {
              const isDisabled =
                !isEnabledByMessage(values?.message) || !isEditMode || isPast;

              return (
                <CheckboxCell
                  name={closedFieldName}
                  disabled={isDisabled}
                  grayed={isGrayed}
                />
              );
            }}
          </PureFieldCell>
        );
      })}
    </TableRow>
  );
};

export const RoomStopSellRow = React.memo(RoomStopSellRowComponent);
